import { render, staticRenderFns } from "./LessonsHistory.vue?vue&type=template&id=2fa0f705&"
import script from "./LessonsHistory.vue?vue&type=script&lang=js&"
export * from "./LessonsHistory.vue?vue&type=script&lang=js&"
import style0 from "./LessonsHistory.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./LessonsHistory.vue?vue&type=style&index=1&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../Яндекс.Игнор/PhpStormProject/app.glavdor.pro/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports